import { render } from "./EditableZoneTable.vue?vue&type=template&id=aa896ace&scoped=true"
import script from "./EditableZoneTable.vue?vue&type=script&lang=js"
export * from "./EditableZoneTable.vue?vue&type=script&lang=js"

import "./EditableZoneTable.vue?vue&type=style&index=0&id=aa896ace&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-aa896ace"

export default script